export default "__VITE_ASSET__EUWvBvNMAolt5mlMSnwB2g__"